{
  "about.blocks": "অনুপলব্ধ সার্ভার",
  "about.contact": "যোগাযোগ:",
  "about.disclaimer": "ম্যাস্টোডন একটি ফ্রি, ওপেন সোর্স সফটওয়্যার এবং ম্যাস্টোডন জিজিএমবিএইচ এর একটি ট্রেডমার্ক।",
  "about.domain_blocks.no_reason_available": "কারণ দর্শানো যাচ্ছে না",
  "about.domain_blocks.preamble": "ম্যাস্টোডন সাধারণত আপনাকে ফেদিভার্স এ অন্য কোনও সার্ভারের ব্যবহারকারীদের থেকে সামগ্রী দেখতে এবং তাদের সাথে আলাপচারিতা করার সুযোগ দেয়। এই ব্যতিক্রম যে এই বিশেষ সার্ভারে তৈরি করা হয়েছে।",
  "about.domain_blocks.silenced.explanation": "আপনি সাধারণত এই সার্ভার থেকে প্রোফাইল এবং বিষয়বস্তু দেখতে পারবেন না, যদি না আপনি নিজে থেকেই এটাকে ফলো না করেন.",
  "about.domain_blocks.silenced.title": "সীমিত",
  "about.domain_blocks.suspended.explanation": "এই সার্ভার থেকে কোনও ডেটা প্রক্রিয়াজাতকরণ, সংরক্ষণ বা আদান-প্রদান করা হবে না, তাই এই সার্ভার ব্যবহারকারীদের সাথে কোনও মিথস্ক্রিয়া বা যোগাযোগকে অসম্ভব করে তুলেছে।",
  "about.domain_blocks.suspended.title": "সাসপেন্ড করা হয়েছে",
  "about.not_available": "এই তথ্য এই সার্ভারে উন্মুক্ত করা হয়নি.",
  "about.powered_by": "{mastodon} দ্বারা তৈরি বিকেন্দ্রীভূত সামাজিক মিডিয়া।",
  "about.rules": "সার্ভারের নিয়মাবলী",
  "account.account_note_header": "ব্যক্তিগত টীকা",
  "account.add_or_remove_from_list": "তালিকাতে যোগ বা অপসারণ করো",
  "account.badges.bot": "বট",
  "account.badges.group": "দল",
  "account.block": "@{name} কে ব্লক করো",
  "account.block_domain": "{domain} কে ব্লক করুন",
  "account.block_short": "ব্লক",
  "account.blocked": "অবরুদ্ধ",
  "account.cancel_follow_request": "অনুসরণ অনুরোধ প্রত্যাহার করুন",
  "account.copy": "অবতারের সংযোগ অনুলিপি করো",
  "account.direct": "গোপনে মেনশন করুন @{name}",
  "account.disable_notifications": "আমাকে জানানো বন্ধ করো যখন @{name} পোস্ট করবে",
  "account.edit_profile": "প্রোফাইল সম্পাদনা করুন",
  "account.enable_notifications": "আমাকে জানাবে যখন @{name} পোস্ট করবে",
  "account.endorse": "প্রোফাইলে ফিচার করুন",
  "account.follow": "অনুসরণ",
  "account.follow_back": "তাকে অনুসরণ করো",
  "account.followers": "অনুসরণকারী",
  "account.followers.empty": "এই ব্যক্তিকে এখনো কেউ অনুসরণ করে না.",
  "account.following": "অনুসরণ করা হচ্ছে",
  "account.follows.empty": "এই সদস্য কাউকে এখনো ফলো করেন না.",
  "account.go_to_profile": "প্রোফাইলে যান",
  "account.hide_reblogs": "@{name}'র সমর্থনগুলি লুকিয়ে ফেলুন",
  "account.in_memoriam": "স্মৃতিতে.",
  "account.joined_short": "যোগ দিয়েছেন",
  "account.languages": "সাবস্ক্রাইব করা ভাষা পরিবর্তন করুন",
  "account.link_verified_on": "এই লিংকের মালিকানা চেক করা হয়েছে {date} তারিখে",
  "account.locked_info": "এই একাউন্ট লক করা। উনি যাদেরকে ফলো করার অনুমতি যাদেরকে দেবেন, শুধু তারাই ফলো করতে পারবেন.",
  "account.media": "মিডিয়া",
  "account.mention": "@{name} কে মেনশন করুন",
  "account.moved_to": "{name} নির্দেশ করেছে যে তাদের নতুন অ্যাকাউন্ট এখন হলো:",
  "account.mute": "@{name} কে নিঃশব্দ করুন",
  "account.mute_notifications_short": "নোটিফিকেশন মিউট করুন",
  "account.mute_short": "মিউট করুন",
  "account.muted": "মিউট করা",
  "account.no_bio": "কোনো বর্ণনা দেওয়া হয়নি.",
  "account.open_original_page": "মূল পৃষ্ঠা খুলুন",
  "account.posts": "পোষ্টসমূহ",
  "account.report": "@{name} কে রিপোর্ট করুন",
  "account.requested_follow": "{name} আপনাকে অনুসরণ করার জন্য অনুরোধ করেছে",
  "account.share": "@{name} র প্রোফাইল অন্যদের দেখান",
  "account.show_reblogs": "@{name} র সমর্থনগুলো দেখান",
  "account.unblock": "@{name} র কার্যকলাপ দেখুন",
  "account.unblock_domain": "{domain} কে আবার দেখুন",
  "account.unblock_short": "আনব্লক করুন",
  "account.unendorse": "আপনার নিজের পাতায় এটা দেখবেন না",
  "account.unfollow": "অনুসরণ করো না",
  "account.unmute": "@{name} র কার্যকলাপ আবার দেখুন",
  "account.unmute_notifications_short": "বিজ্ঞপ্তি শব্দ চালু করো",
  "account.unmute_short": "আনমিউট করুন",
  "account_note.placeholder": "নোট যোগ করতে ক্লিক করুন",
  "admin.dashboard.daily_retention": "সাইন আপের পর দিনে ব্যবহারকারীর ধরে রাখার হার",
  "admin.dashboard.monthly_retention": "সাইন আপের পর, দিনে ব্যবহারকারীর ধরে রাখার হার",
  "admin.dashboard.retention.average": "গড়",
  "admin.dashboard.retention.cohort": "সাইন আপের মাস",
  "admin.dashboard.retention.cohort_size": "নতুন ব্যবহারকারী",
  "admin.impact_report.instance_accounts": "যেসব একাউন্ট এর প্রোফাইল এটি ডিলিট করবে",
  "admin.impact_report.instance_followers": "যেসব ফলোয়ারদের আমাদের ইউজাররা হারাবে",
  "admin.impact_report.instance_follows": "যেসব ফলোয়ারদের তাদের ইউজার হারাবে",
  "alert.rate_limited.message": "{retry_time, time, medium} -এর পরে আবার প্রচেষ্টা করুন।",
  "alert.rate_limited.title": "হার সীমিত",
  "alert.unexpected.message": "সমস্যা অপ্রত্যাশিত.",
  "alert.unexpected.title": "ওহো!",
  "announcement.announcement": "ঘোষণা",
  "attachments_list.unprocessed": "(প্রক্রিয়া করা যায়নি)",
  "audio.hide": "অডিও লুকান",
  "boost_modal.combo": "পরেরবার আপনি {combo} টিপলে এটি আর আসবে না",
  "bundle_column_error.copy_stacktrace": "এরর রিপোর্ট কপি করুন",
  "bundle_column_error.error.body": "অনুরোধ করা পৃষ্ঠাটি রেন্ডার করা যায়নি। এটি আমাদের কোডে একটি বাগ বা ব্রাউজার সামঞ্জস্যের সমস্যার কারণে হতে পারে।",
  "bundle_column_error.error.title": "হায়, না!",
  "bundle_column_error.network.body": "এই পৃষ্ঠাটি লোড করার চেষ্টা করার সময় একটি ত্রুটি ছিল৷ এটি আপনার ইন্টারনেট সংযোগ বা এই সার্ভারের সাথে একটি অস্থায়ী সমস্যার কারণে হতে পারে৷",
  "bundle_column_error.network.title": "নেটওয়ার্ক ত্রুটি",
  "bundle_column_error.retry": "আবার চেষ্টা করুন",
  "bundle_column_error.return": "হোমে ফিরে যান",
  "bundle_column_error.routing.body": "অনুরোধ করা পৃষ্ঠা খুঁজে পাওয়া যাবে না। আপনি কি নিশ্চিত যে ঠিকানা বারে ইউআরএলটি সঠিক?",
  "bundle_column_error.routing.title": "৪০৪",
  "bundle_modal_error.close": "বন্ধ করুন",
  "bundle_modal_error.retry": "আবার চেষ্টা করুন",
  "closed_registrations.other_server_instructions": "মাস্টোডন বিকেন্দ্রীভূত হওয়ায়, আপনি অন্য সার্ভারে একটি অ্যাকাউন্ট তৈরি করতে পারেন এবং এখনও এটির সাথে যোগাযোগ করতে পারেন।",
  "closed_registrations_modal.description": "{domain} এ একটি অ্যাকাউন্ট তৈরি করা বর্তমানে সম্ভব নয়, তবে দয়া করে মনে রাখবেন যে ম্যাস্টোডন ব্যবহার করার জন্য আপনার বিশেষভাবে {domain} এ কোনো অ্যাকাউন্টের প্রয়োজন নেই৷",
  "closed_registrations_modal.find_another_server": "অন্য একটি সার্ভার খুজুন",
  "closed_registrations_modal.preamble": "ম্যাস্টোডন বিকেন্দ্রীকৃত, তাই আপনি যেখানেই আপনার অ্যাকাউন্ট তৈরি করুন না কেন, আপনি এই সার্ভারে যে কাউকে অনুসরণ করতে এবং যোগাযোগ করতে সক্ষম হবেন। এমনকি আপনি এটি স্ব-হোস্ট করতে পারেন!",
  "closed_registrations_modal.title": "ম্যাস্টোডন এ সাইন আপ করা হচ্ছে",
  "column.about": "সম্পর্কে",
  "column.blocks": "যাদের ব্লক করা হয়েছে",
  "column.bookmarks": "বুকমার্ক",
  "column.community": "স্থানীয় সময়সারি",
  "column.direct": "গোপনে মেনশন করুন",
  "column.directory": "প্রোফাইল ব্রাউজ করুন",
  "column.domain_blocks": "লুকোনো ডোমেনগুলি",
  "column.favourites": "পছন্দসমূহ",
  "column.firehose": "সরাসরি প্রবাহ",
  "column.follow_requests": "অনুসরণের অনুমতি অনুরোধকারী",
  "column.home": "বাড়ি",
  "column.lists": "তালিকাগুলো",
  "column.mutes": "যাদের কার্যক্রম দেখা বন্ধ আছে",
  "column.notifications": "প্রজ্ঞাপনগুলো",
  "column.pins": "পিন করা টুট",
  "column.public": "যুক্ত সময়রেখা",
  "column_back_button.label": "পেছনে",
  "column_header.hide_settings": "সেটিংগুলো সরান",
  "column_header.moveLeft_settings": "কলমটা বামে সরান",
  "column_header.moveRight_settings": "কলমটা ডানে সরান",
  "column_header.pin": "পিন দিয়ে রাখুন",
  "column_header.show_settings": "সেটিং দেখান",
  "column_header.unpin": "পিন খুলুন",
  "community.column_settings.local_only": "শুধুমাত্র স্থানীয়",
  "community.column_settings.media_only": "শুধুমাত্র ছবি বা ভিডিও",
  "community.column_settings.remote_only": "শুধুমাত্র দূরবর্তী",
  "compose.language.change": "ভাষা পরিবর্তন করুন",
  "compose.language.search": "ভাষা অনুসন্ধান করুন...",
  "compose.published.body": "পোষ্ট publish করা হয়েছে.",
  "compose.published.open": "দেখো",
  "compose.saved.body": "পোস্ট সংরক্ষণ করা হয়েছে.",
  "compose_form.direct_message_warning_learn_more": "আরো জানুন",
  "compose_form.encryption_warning": "Posts on Mastodon are not end-to-end encrypted. Do not share any dangerous information over Mastodon.",
  "compose_form.hashtag_warning": "এই পোস্টটি কোনো হ্যাশট্যাগের বিষয় নয় কারণ এটি সর্বজনীনভাবে উপলব্ধ নয়। শুধুমাত্র জনসাধারণের কাছে পোস্ট করা বার্তাই হ্যাশট্যাগ দ্বারা অনুসন্ধান করা যেতে পারে।",
  "compose_form.lock_disclaimer": "আপনার নিবন্ধনে তালা দেওয়া নেই, যে কেও আপনাকে অনুসরণ করতে পারবে এবং অনুশারকদের জন্য লেখা দেখতে পারবে।",
  "compose_form.lock_disclaimer.lock": "তালা দেওয়া",
  "compose_form.placeholder": "আপনি কি ভাবছেন ?",
  "compose_form.poll.duration": "ভোটগ্রহনের সময়",
  "compose_form.poll.switch_to_multiple": "একাধিক পছন্দ অনুমতি দেওয়ার জন্য পোল পরিবর্তন করুন",
  "compose_form.poll.switch_to_single": "একটি একক পছন্দের অনুমতি দেওয়ার জন্য পোল পরিবর্তন করুন",
  "compose_form.spoiler.marked": "সতর্কতার পিছনে লেখানটি লুকানো আছে",
  "compose_form.spoiler.unmarked": "লেখাটি লুকানো নেই",
  "confirmation_modal.cancel": "বাতিল করুন",
  "confirmations.block.confirm": "ব্লক করুন",
  "confirmations.delete.confirm": "মুছে ফেলুন",
  "confirmations.delete.message": "আপনি কি নিশ্চিত যে এই লেখাটি মুছে ফেলতে চান ?",
  "confirmations.delete_list.confirm": "মুছে ফেলুন",
  "confirmations.delete_list.message": "আপনি কি নিশ্চিত যে আপনি এই তালিকাটি স্থায়িভাবে মুছে ফেলতে চান ?",
  "confirmations.discard_edit_media.confirm": "বাতিল করো",
  "confirmations.discard_edit_media.message": "মিডিয়া Description বা Preview তে আপনার আপনার অসংরক্ষিত পরিবর্তন আছে, সেগুলো বাতিল করবেন?",
  "confirmations.logout.confirm": "প্রস্থান",
  "confirmations.logout.message": "আপনি লগ আউট করতে চান?",
  "confirmations.mute.confirm": "সরিয়ে ফেলুন",
  "confirmations.redraft.confirm": "মুছে ফেলুন এবং আবার সম্পাদন করুন",
  "confirmations.unfollow.confirm": "অনুসরণ বন্ধ করো",
  "conversation.delete": "কথোপকথন মুছে ফেলুন",
  "conversation.mark_as_read": "পঠিত হিসেবে চিহ্নিত করুন",
  "conversation.open": "কথপোকথন দেখান",
  "conversation.with": "{names} এর সঙ্গে",
  "copypaste.copied": "অনুলিপিকৃত",
  "copypaste.copy_to_clipboard": "ক্লিপবোর্ডে কপি করুন",
  "directory.federated": "পরিচিত ফেডিভারসের থেকে",
  "directory.local": "শুধু {domain} থেকে",
  "directory.new_arrivals": "নতুন আগত",
  "directory.recently_active": "সম্প্রতি সক্রিয়",
  "disabled_account_banner.account_settings": "একাউন্ট সেটিংস",
  "disabled_account_banner.text": "আপনার একাউন্ট {disabledAccount} বর্তমানে বন্ধ করা.",
  "dismissable_banner.dismiss": "সরাও",
  "embed.instructions": "এই লেখাটি আপনার ওয়েবসাইটে যুক্ত করতে নিচের কোডটি বেবহার করুন।",
  "embed.preview": "সেটা দেখতে এরকম হবে:",
  "emoji_button.activity": "কার্যকলাপ",
  "emoji_button.clear": "পরিষ্কার",
  "emoji_button.custom": "প্রথা",
  "emoji_button.flags": "পতাকা",
  "emoji_button.food": "খাদ্য ও পানীয়",
  "emoji_button.label": "এমজি যুক্ত করুন",
  "emoji_button.nature": "প্রকৃতি",
  "emoji_button.not_found": "ইমোজি পাওয়া যায়নি !! (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "বস্তূ",
  "emoji_button.people": "মানুষ",
  "emoji_button.recent": "ঘন ব্যাবহৃত",
  "emoji_button.search": "খুজুন...",
  "emoji_button.search_results": "খোঁজার ফলাফল",
  "emoji_button.symbols": "প্রতীক",
  "emoji_button.travel": "ভ্রমণ এবং স্থান",
  "empty_column.account_timeline": "এখানে কোনো টুট নেই!",
  "empty_column.account_unavailable": "নিজস্ব পাতা নেই",
  "empty_column.blocks": "আপনি কোনো ব্যবহারকারীদের ব্লক করেন নি।",
  "empty_column.bookmarked_statuses": "আপনার কাছে এখনও কোনও বুকমার্কড টুট নেই। আপনি যখন একটি বুকমার্ক করেন, এটি এখানে প্রদর্শিত হবে।",
  "empty_column.community": "স্থানীয় সময়রেখাতে কিছু নেই। প্রকাশ্যভাবে কিছু লিখে লেখালেখির উদ্বোধন করে ফেলুন!",
  "empty_column.domain_blocks": "এখনও কোনও লুকানো ডোমেন নেই।",
  "empty_column.follow_requests": "তোমার এখনো কোনো অনুসরণের আবেদন পাওনি। যদি কেউ পাঠায়, এখানে পাওয়া যাবে।",
  "empty_column.hashtag": "এই হেসটাগে এখনো কিছু নেই।",
  "empty_column.home": "আপনার বাড়ির সময়রেখা এখনো খালি!  {public} এ ঘুরে আসুন অথবা অনুসন্ধান বেবহার করে শুরু করতে পারেন এবং অন্য ব্যবহারকারীদের সাথে সাক্ষাৎ করতে পারেন।",
  "empty_column.list": "এই তালিকাতে এখনো কিছু নেই. যখন এই তালিকায় থাকা ব্যবহারকারী নতুন কিছু লিখবে, সেগুলো এখানে পাওয়া যাবে।",
  "empty_column.mutes": "আপনি এখনো কোনো ব্যবহারকারীকে নিঃশব্দ করেননি।",
  "empty_column.notifications": "আপনার এখনো কোনো প্রজ্ঞাপন নেই। কথোপকথন শুরু করতে,  অন্যদের সাথে মেলামেশা করতে পারেন।",
  "empty_column.public": "এখানে এখনো কিছু নেই! প্রকাশ্য ভাবে কিছু লিখুন বা অন্য সার্ভার থেকে কাওকে অনুসরণ করে এই জায়গা ভরে ফেলুন",
  "error.unexpected_crash.explanation": "আমাদের কোড বা ব্রাউজারের সামঞ্জস্য ইস্যুতে একটি বাগের কারণে এই পৃষ্ঠাটি সঠিকভাবে প্রদর্শিত করা যায় নি।",
  "error.unexpected_crash.next_steps": "পাতাটি রিফ্রেশ করে চেষ্টা করুন। তবুও যদি না হয়, তবে আপনি অন্য একটি ব্রাউজার অথবা আপনার ডিভাইসের জন্যে এপের মাধ্যমে মাস্টডন ব্যাবহার করতে পারবেন।.",
  "errors.unexpected_crash.copy_stacktrace": "স্টেকট্রেস ক্লিপবোর্ডে কপি করুন",
  "errors.unexpected_crash.report_issue": "সমস্যার প্রতিবেদন করুন",
  "explore.suggested_follows": "মানুষ",
  "explore.trending_links": "সংবাদ",
  "explore.trending_statuses": "পোস্ট",
  "explore.trending_tags": "হ্যাশট্যাগ",
  "filter_modal.select_filter.expired": "মেয়াদোত্তীর্ণ",
  "firehose.all": "সব",
  "firehose.local": "এই সার্ভার",
  "follow_request.authorize": "অনুমতি দিন",
  "follow_request.reject": "প্রত্যাখ্যান করুন",
  "follow_requests.unlocked_explanation": "আপনার অ্যাকাউন্টটি লক না থাকলেও, {domain} কর্মীরা ভেবেছিলেন যে আপনি এই অ্যাকাউন্টগুলি থেকে ম্যানুয়ালি অনুসরণের অনুরোধগুলি পর্যালোচনা করতে চাইতে পারেন।",
  "footer.about": "পরিচিতি",
  "footer.get_app": "অ্যাপ নামাও",
  "footer.status": "অবস্থা",
  "generic.saved": "সংরক্ষণ হয়েছে",
  "getting_started.heading": "শুরু করা",
  "hashtag.column_header.tag_mode.all": "এবং {additional}",
  "hashtag.column_header.tag_mode.any": "অথবা {additional}",
  "hashtag.column_header.tag_mode.none": "{additional} বাদ দিয়ে",
  "hashtag.column_settings.select.no_options_message": "কোনটা পাওয়া যায় নি",
  "hashtag.column_settings.select.placeholder": "হ্যাশট্যাগের ভেতরে ঢুকুন…",
  "hashtag.column_settings.tag_mode.all": "এগুলো সব",
  "hashtag.column_settings.tag_mode.any": "এর ভেতরে যেকোনোটা",
  "hashtag.column_settings.tag_mode.none": "এগুলোর একটাও না",
  "hashtag.column_settings.tag_toggle": "আরো ট্যাগ এই কলামে যুক্ত করতে",
  "home.column_settings.show_reblogs": "সমর্থনগুলো দেখান",
  "home.column_settings.show_replies": "মতামত দেখান",
  "home.hide_announcements": "ঘোষণা লুকান",
  "home.show_announcements": "ঘোষণা দেখান",
  "intervals.full.hours": "{number, plural, one {# ঘটা} other {# ঘটা}}",
  "intervals.full.minutes": "{number, plural, one {# মিনিট} other {# মিনিট}}",
  "keyboard_shortcuts.back": "পেছনে যেতে",
  "keyboard_shortcuts.blocked": "ব্লক করা ব্যবহারকারীদের তালিকা খুলতে",
  "keyboard_shortcuts.boost": "সমর্থন করতে",
  "keyboard_shortcuts.column": "কোনো কলামএ কোনো লেখা ফোকাস করতে",
  "keyboard_shortcuts.compose": "লেখা সম্পদনার জায়গায় ফোকাস করতে",
  "keyboard_shortcuts.description": "বিবরণ",
  "keyboard_shortcuts.down": "তালিকার ভেতরে নিচে যেতে",
  "keyboard_shortcuts.enter": "অবস্থা দেখতে",
  "keyboard_shortcuts.federated": "যুক্তবিশ্বের সময়রেখাতে যেতে",
  "keyboard_shortcuts.heading": "কিবোর্ডের দ্রুতকারক (শর্টকাট)",
  "keyboard_shortcuts.home": "বাড়ির সময়রেখা খুলতে",
  "keyboard_shortcuts.hotkey": "দ্রুতকারক ছবিগুলো",
  "keyboard_shortcuts.legend": "এই প্রদর্শনঅর্থ(legend) দেখতে",
  "keyboard_shortcuts.local": "স্থানীয় সময়রেখাতে যেতে",
  "keyboard_shortcuts.mention": "লেখককে উল্লেখ করতে",
  "keyboard_shortcuts.muted": "বন্ধ করা ব্যবহারকারীদের তালিকা খুলতে",
  "keyboard_shortcuts.my_profile": "আপনার নিজের পাতা দেখতে",
  "keyboard_shortcuts.notifications": "প্রজ্ঞাপনের কলাম খুলতে",
  "keyboard_shortcuts.open_media": "মিডিয়া খলার জন্য",
  "keyboard_shortcuts.pinned": "পিন দেওয়া টুটের তালিকা খুলতে",
  "keyboard_shortcuts.profile": "লেখকের পাতা দেখতে",
  "keyboard_shortcuts.reply": "মতামত দিতে",
  "keyboard_shortcuts.requests": "অনুসরণ অনুরোধের তালিকা দেখতে",
  "keyboard_shortcuts.search": "খোঁজার অংশে ফোকাস করতে",
  "keyboard_shortcuts.spoilers": "CW ক্ষেত্র দেখাবার/লুকবার জন্য",
  "keyboard_shortcuts.start": "\"প্রথম শুরুর\" কলাম বের করতে",
  "keyboard_shortcuts.toggle_hidden": "CW লেখা দেখতে বা লুকাতে",
  "keyboard_shortcuts.toggle_sensitivity": "ভিডিও/ছবি দেখতে বা বন্ধ করতে",
  "keyboard_shortcuts.toot": "নতুন একটা টুট লেখা শুরু করতে",
  "keyboard_shortcuts.unfocus": "লেখা বা খোঁজার জায়গায় ফোকাস না করতে",
  "keyboard_shortcuts.up": "তালিকার উপরের দিকে যেতে",
  "lightbox.close": "বন্ধ",
  "lightbox.next": "পরবর্তী",
  "lightbox.previous": "পূর্ববর্তী",
  "link_preview.author": "{name} এর লিখা",
  "lists.delete": "তালিকা মুছে ফেলতে",
  "lists.edit": "তালিকা সম্পাদনা করতে",
  "lists.replies_policy.none": "কেউ না",
  "load_pending": "{count, plural, one {# নতুন জিনিস} other {# নতুন জিনিস}}",
  "navigation_bar.about": "পরিচিতি",
  "navigation_bar.blocks": "বন্ধ করা ব্যবহারকারী",
  "navigation_bar.bookmarks": "বুকমার্ক",
  "navigation_bar.domain_blocks": "লুকানো ডোমেনগুলি",
  "navigation_bar.favourites": "পছন্দসমূহ",
  "navigation_bar.filters": "বন্ধ করা শব্দ",
  "navigation_bar.follow_requests": "অনুসরণের অনুরোধগুলি",
  "navigation_bar.follows_and_followers": "অনুসরণ এবং অনুসরণকারী",
  "navigation_bar.lists": "তালিকাগুলো",
  "navigation_bar.logout": "বাইরে যান",
  "navigation_bar.mutes": "যাদের কার্যক্রম দেখা বন্ধ আছে",
  "navigation_bar.preferences": "পছন্দসমূহ",
  "navigation_bar.search": "অনুসন্ধান",
  "not_signed_in_indicator.not_signed_in": "You need to sign in to access this resource.",
  "notification.follow": "{name} আপনাকে অনুসরণ করেছেন",
  "notification.follow_request": "{name} আপনাকে অনুসরণ করার জন্য অনুরধ করেছে",
  "notification.own_poll": "আপনার পোল শেষ হয়েছে",
  "notification.reblog": "{name} আপনার কার্যক্রমে সমর্থন দেখিয়েছেন",
  "notifications.clear": "প্রজ্ঞাপনগুলো মুছে ফেলতে",
  "notifications.clear_confirmation": "আপনি কি নির্চিত প্রজ্ঞাপনগুলো মুছে ফেলতে চান ?",
  "notifications.column_settings.alert": "কম্পিউটারে প্রজ্ঞাপনগুলি",
  "notifications.column_settings.favourite": "পছন্দসমূহ:",
  "notifications.column_settings.follow": "নতুন অনুসরণকারীরা:",
  "notifications.column_settings.follow_request": "অনুসরণের অনুরোধগুলি:",
  "notifications.column_settings.mention": "প্রজ্ঞাপনগুলো:",
  "notifications.column_settings.poll": "নির্বাচনের ফলাফল:",
  "notifications.column_settings.push": "পুশ প্রজ্ঞাপনগুলি",
  "notifications.column_settings.reblog": "সমর্থনগুলো:",
  "notifications.column_settings.show": "কলামে দেখানো",
  "notifications.column_settings.sound": "শব্দ বাজানো",
  "notifications.column_settings.status": "New toots:",
  "notifications.column_settings.update": "সম্পাদনা:",
  "notifications.filter.all": "সব",
  "notifications.filter.boosts": "সমর্থনগুলো",
  "notifications.filter.favourites": "পছন্দসমূহ",
  "notifications.filter.follows": "অনুসরণের",
  "notifications.filter.mentions": "উল্লেখিত",
  "notifications.filter.polls": "নির্বাচনের ফলাফল",
  "notifications.group": "{count} প্রজ্ঞাপন",
  "picture_in_picture.restore": "ফিরত রাখো",
  "poll.closed": "বন্ধ",
  "poll.refresh": "বদলেছে কিনা দেখতে",
  "poll.reveal": "ফলাফল দেখো",
  "poll.total_people": "{count, plural, one {# ব্যক্তি} other {# ব্যক্তি}}",
  "poll.total_votes": "{count, plural, one {# ভোট} other {# ভোট}}",
  "poll.vote": "ভোট",
  "poll.voted": "আপনি এই উত্তরের পক্ষে ভোট দিয়েছেন",
  "poll_button.add_poll": "একটা নির্বাচন যোগ করতে",
  "poll_button.remove_poll": "নির্বাচন বাদ দিতে",
  "privacy.change": "লেখার গোপনীয়তা অবস্থা ঠিক করতে",
  "privacy.public.short": "সর্বজনীন প্রকাশ্য",
  "refresh": "সতেজ করা",
  "relative_time.days": "{number} দিন",
  "relative_time.full.just_now": "এইমাত্র",
  "relative_time.hours": "{number} ঘন্টা",
  "relative_time.just_now": "এখন",
  "relative_time.minutes": "{number}মিঃ",
  "relative_time.seconds": "{number} সেকেন্ড",
  "relative_time.today": "আজ",
  "reply_indicator.cancel": "বাতিল করতে",
  "report.block": "অবরোধ",
  "report.categories.other": "অন্যান্য",
  "report.categories.spam": "স্প্যাম",
  "report.category.title_account": "প্রোফাইল",
  "report.category.title_status": "পোস্ট",
  "report.close": "সম্পন্ন",
  "report.forward": "এটা আরো পাঠান {target} তে",
  "report.forward_hint": "এই নিবন্ধনটি অন্য একটি সার্ভারে। অপ্রকাশিতনামাভাবে রিপোর্টের কপি সেখানেও কি পাঠাতে চান ?",
  "report.mute": "নিঃশব্দ",
  "report.next": "পরবর্তী",
  "report.placeholder": "অন্য কোনো মন্তব্য",
  "report.reasons.spam": "এটি স্প্যাম",
  "report.submit": "জমা দিন",
  "report.target": "{target} রিপোর্ট করুন",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "report_notification.categories.legal": "আইনি",
  "report_notification.categories.other": "অন্যান্য",
  "report_notification.categories.spam": "স্প্যাম",
  "search.placeholder": "অনুসন্ধান",
  "search_results.accounts": "প্রোফাইল",
  "search_results.all": "সব",
  "search_results.hashtags": "হ্যাশট্যাগগুলি",
  "search_results.statuses": "টুট",
  "sign_in_banner.sign_in": "Sign in",
  "status.admin_account": "@{name} র জন্য পরিচালনার ইন্টারফেসে ঢুকুন",
  "status.admin_status": "যায় লেখাটি পরিচালনার ইন্টারফেসে খুলুন",
  "status.block": "@{name} কে ব্লক করুন",
  "status.bookmark": "বুকমার্ক",
  "status.cancel_reblog_private": "সমর্থন বাতিল করতে",
  "status.cannot_reblog": "এটিতে সমর্থন দেওয়া যাবেনা",
  "status.copy": "লেখাটির লিংক কপি করতে",
  "status.delete": "মুছে ফেলতে",
  "status.detailed_status": "বিস্তারিত কথোপকথনের হিসেবে দেখতে",
  "status.edit": "সম্পাদন",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.favourite": "পছন্দ",
  "status.load_more": "আরো দেখুন",
  "status.media_hidden": "মিডিয়া লুকানো আছে",
  "status.mention": "@{name}কে উল্লেখ করতে",
  "status.more": "আরো",
  "status.mute": "@{name}র কার্যক্রম সরিয়ে ফেলতে",
  "status.mute_conversation": "কথোপকথননের প্রজ্ঞাপন সরিয়ে ফেলতে",
  "status.open": "এটার সম্পূর্ণটা দেখতে",
  "status.pin": "নিজের পাতায় এটা পিন করতে",
  "status.read_more": "আরো পড়ুন",
  "status.reblog": "সমর্থন দিতে",
  "status.reblogged_by": "{name} সমর্থন দিয়েছে",
  "status.reblogs.empty": "এখনো কেও এটাতে সমর্থন দেয়নি। যখন কেও দেয়, সেটা তখন এখানে দেখা যাবে।",
  "status.redraft": "মুছে আবার নতুন করে লিখতে",
  "status.remove_bookmark": "বুকমার্ক সরান",
  "status.reply": "মতামত জানাতে",
  "status.replyAll": "লেখাযুক্ত সবার কাছে মতামত জানাতে",
  "status.report": "@{name} কে রিপোর্ট করতে",
  "status.sensitive_warning": "সংবেদনশীল কিছু",
  "status.share": "অন্যদের জানান",
  "status.show_less_all": "সবগুলোতে কম দেখতে",
  "status.show_more_all": "সবগুলোতে আরো দেখতে",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.translate": "অনুবাদ",
  "status.unmute_conversation": "আলোচনার প্রজ্ঞাপন চালু করতে",
  "status.unpin": "নিজের পাতা থেকে পিন করে রাখাটির পিন খুলতে",
  "tabs_bar.home": "বাড়ি",
  "tabs_bar.notifications": "প্রজ্ঞাপনগুলো",
  "time_remaining.days": "{number, plural, one {# day} other {# days}} বাকি আছে",
  "time_remaining.hours": "{number, plural, one {# hour} other {# hours}} বাকি আছে",
  "time_remaining.minutes": "{number, plural, one {# মিনিট} other {# মিনিট}} বাকি আছে",
  "time_remaining.moments": "সময় বাকি আছে",
  "time_remaining.seconds": "{number, plural, one {# second} other {# seconds}} বাকি আছে",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "trends.trending_now": "বর্তমানে জনপ্রিয়",
  "ui.beforeunload": "যে পর্যন্ত এটা লেখা হয়েছে, মাস্টাডন থেকে চলে গেলে এটা মুছে যাবে।",
  "units.short.billion": "{count}বিলিয়ন",
  "units.short.million": "{count}মিলিওন",
  "units.short.thousand": "{count}হাজার",
  "upload_area.title": "টেনে এখানে ছেড়ে দিলে এখানে যুক্ত করা যাবে",
  "upload_button.label": "ছবি বা ভিডিও যুক্ত করতে (এসব ধরণের: JPEG, PNG, GIF, WebM, MP4, MOV)",
  "upload_error.limit": "যা যুক্ত করতে চাচ্ছেন সেটি বেশি বড়, এখানকার সর্বাধিকের মেমোরির উপরে চলে গেছে।",
  "upload_error.poll": "নির্বাচনক্ষেত্রে কোনো ফাইল যুক্ত করা যাবেনা।",
  "upload_form.edit": "সম্পাদন",
  "upload_progress.label": "যুক্ত করতে পাঠানো হচ্ছে...",
  "video.close": "ভিডিওটি বন্ধ করতে",
  "video.download": "ফাইলটি ডাউনলোড করুন",
  "video.exit_fullscreen": "পূর্ণ পর্দা থেকে বাইরে বের হতে",
  "video.expand": "ভিডিওটি বড়ো করতে",
  "video.fullscreen": "পূর্ণ পর্দা করতে",
  "video.hide": "ভিডিওটি লুকাতে",
  "video.pause": "থামাতে",
  "video.play": "শুরু করতে"
}
